<form #myform="ngForm" class="form-group" style="height: 100%">
  <!--Form Header-->
  <div class="formpage-header">
    <h3 class="page-titre">
      <mat-icon>business_center</mat-icon>
      {{ titre }}
    </h3>
  </div>

  <!--Form Body-->
  <div class="formpage-body" *ngIf="currentPicklistHeader">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>ID Entête</mat-label>
        <input matInput [(ngModel)]="currentPicklistHeader.PickListHeaderID" name="PickListHeaderID" class="form-control" disabled="true" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nombre d'employés</mat-label>
        <input matInput [(ngModel)]="currentPicklistHeader.NumberOfSplits" type="number" name="NumberOfSplits" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Type de l'impression</mat-label>
        <input matInput [(ngModel)]="currentPicklistHeader.OutputType" type="string" name="OutputType" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Date de début</mat-label>
        <input matInput [(ngModel)]="currentPicklistHeader.StartDate" type="string" name="StartDate" disabled="true" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Date de fin</mat-label>
        <input matInput [(ngModel)]="currentPicklistHeader.EndDate" type="string" name="EndDate" disabled="true" />
      </mat-form-field>
    </div>
  </div>

  <!--Form Footer-->
  <div class="formpage-footer">
    <button type="button" matInput mat-stroked-button (click)="detruire()" [disabled]="true" style="margin: 0px 2px 2px 2px">
      <mat-icon>delete</mat-icon>Supprimer
    </button>

    <div style="float: right">
      <button type="submit" matInput mat-flat-button (click)="OnSauvegardeClick()" *ngIf="!myform.pristine" color="primary" style="margin: 0px 2px 2px 2px">
        <mat-icon>check</mat-icon>Créer la picklist
      </button>
      <button type="submit" matInput mat-stroked-button (click)="annuler()" *ngIf="myform.pristine" style="margin: 0px 2px 2px 2px">Fermer</button>
      <button type="button" matInput mat-stroked-button (click)="annuler()" *ngIf="!myform.pristine" style="margin: 0px 2px 2px 2px">Ignorer</button>
    </div>
  </div>
</form>
